import { render, staticRenderFns } from "./accoudialog.vue?vue&type=template&id=260c6f12&scoped=true"
import script from "./accoudialog.vue?vue&type=script&lang=js"
export * from "./accoudialog.vue?vue&type=script&lang=js"
import style0 from "./accoudialog.vue?vue&type=style&index=0&id=260c6f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c6f12",
  null
  
)

export default component.exports